import i18n, { Resource } from "i18next"
import { initReactI18next } from "react-i18next"
import { getLocales } from "react-native-localize"

import { isE2EEnvironment } from "../../../features/config/environment"
import { AppUserData } from "../../../features/models/UserData"
import { LanguageSelector } from "../../../screens/LanguageScreen/Constants"
/** Do not shorten to avoid `cycles warning` */
import { COMMON_NAMESPACE } from "./constants"

interface IProps {
  translation: Resource
  userData?: AppUserData
}

const I18nInit: (props: IProps) => typeof i18n = ({ translation, userData }) => {
  const supportedLanguages = LanguageSelector.map(lang => lang.languageCode)

  // Force French locale in e2e environment
  const deviceLanguage = isE2EEnvironment() ? "fr" : getLocales()[0].languageCode

  const fallbackLanguage = "fr"
  const effectiveLanguage = supportedLanguages.includes(deviceLanguage)
    ? deviceLanguage
    : fallbackLanguage

  if (i18n.isInitialized) {
    // Si i18n est déjà initialisé, mettre à jour les ressources et la langue
    // sans réinitialiser complètement
    Object.keys(translation).forEach(lng => {
      Object.keys(translation[lng]).forEach(ns => {
        i18n.addResourceBundle(lng, ns, translation[lng][ns], true, true)
      })
    })

    // Mettre à jour la langue si nécessaire
    const currentLng = userData?.lng || effectiveLanguage
    if (i18n.language !== currentLng) {
      i18n.changeLanguage(currentLng)
    }
  } else {
    // Première initialisation
    i18n.use(initReactI18next).init({
      fallbackLng: fallbackLanguage,
      lng: userData?.lng || effectiveLanguage,
      resources: translation,
      ns: [COMMON_NAMESPACE],
      defaultNS: COMMON_NAMESPACE,
      debug: __DEV__,
      cache: {
        enabled: false,
      },
      react: {
        useSuspense: false,
      },
    })
  }

  return i18n
}

export default I18nInit
